export default {
    associationSettings: {
        digitalSignatureRequired: 'Digitale Unterschrift erforderlich',
        digitalSignatureRequiredDescription: 'Wenn diese Option aktiviert ist, müssen die diesem Verband untergeordneten Organisationen im Antragsbereich Formulare digital unterschreiben, sofern die digitale Unterschrift für das jeweilige Formular verfügbar ist.',
        digitalSignatureOptional: 'Digitale Unterschrift optional',
        digitalSignatureOptionalDescription: 'Wenn diese Option aktiviert ist, können die diesem Verband untergeordneten Organisationen im Antragsbereich Formulare digital unterschreiben, sofern die digitale Unterschrift für das jeweilige Formular verfügbar ist. Die digitale Unterschrift ist jedoch nicht zwingend erforderlich.',
        useBankAccount: 'Bankverbindung verwenden',
        useBankAccountDescription: 'Wenn diese Option aktiviert ist, müssen die diesem Verband untergeordneten Organisationen im Antragsbereich eine Bankverbindung angeben.',

        warningsInfoTitle: 'Mahnungen und Erinnerungen',
        // {highlight} is marked up in the template - no HTML in language strings, see <i18n-t>
        warningsInfo: 'Die Angaben beziehen sich auf die Anzahl der Werktage nach dem jeweiligen Referenzdatum. Die Erinnerung/Mahnung wird am {highlight} verschickt. Wenn das Feld leer ist, wird keine Mail gesendet.',
        warningsInfoHighlight: 'Morgen des angegebenen Werktags',

        goalAgreements: 'Zielvereinbarungen',
        warningGoalAgreementDays: 'Mahnung',
        warningGoalAgreementDaysDescription: 'Anzahl der Werktage nach dem Setzen des Status "ZV Erstellt".',

        transferAgreements: 'Weiterleitungsverträge',
        warningTransferAgreementDays: 'Mahnung',
        warningTransferAgreementDaysDescription: 'Anzahl der Werktage nach dem Setzen des Status "WLV Erstellt".',

        proofs: 'Verwendungsnachweise',
        warningDays: 'Mahnfristen (Werktage nach Maßnahmenende)',
        warningProofDays: '1. Erinnerung',
        secondWarningProofDays: '2. Erinnerung',
        thirdWarningProofDays: 'Mahnung',

        proofDeadlines: 'Abgabefristen (jährlich wiederkehrend, gelten nur wenn eine Frist für die Mahnung definiert wurde)',
        day: 'Tag',
        month: 'Monat',
        proofDeadlineInternational: 'Internationale Begegnungen',
        proofDeadlinePoliticalEducation: 'Politische Bildung (national)',
        proofDeadlineYouthAssociation: 'Jugendverbandsarbeit (national)',

        protectionConcepts: 'Schutzkonzepte',
        protectionConceptValidityYears: 'Gültigkeitsdauer (Jahre)',
        protectionConceptValidityYearsDescription: 'Anzahl der Jahre, nach denen Schutzkonzepte als veraltet gelten und automatisch entfernt werden.',

        websiteContent: 'Inhalte auf der Website',

        contentFrontend: 'Inhalt im Menüpunkt "Info"',
        contentFrontendDescription: 'Dieser Inhalt wird im Antragsbereich unter dem Menüpunkt "Info" für alle angemeldeten Nutzer angezeigt.',
        contentFrontendAlert: 'Hinweis im Antragsbereich',
        contentFrontendAlertDescription: 'Dieser Hinweis wird oben im Antragsbereich angezeigt und ist für alle angemeldeten Nutzer sichtbar, die sich im Antragsbereich befinden.',
        contentDashboard: 'Hinweis im Verwaltungsbereich (Dashboard)',
        contentDashboardDescription: 'Dieser Hinweis wird im Verwaltungsbereich oberhalb der Widgets auf dem Dashboard angezeigt.',
        contentPlaceholder: 'Inhalt',
    },
}